import { z } from "zod";

/**
 * A knowledge base article related to a support case.
 * Served by GET /support/incidents/{number}/articles.
 * Dataverse returns sparse records, so everything but Id is optional.
 */
export const SupportCaseArticleItemSchema = z.object({
  Id: z.string().uuid(),
  Title: z.string().nullable().optional(),
  Number: z.string().nullable().optional(),
  Description: z.string().nullable().optional(),
  Url: z.string().nullable().optional(),
});

export type SupportCaseArticleItemType = z.infer<
  typeof SupportCaseArticleItemSchema
>;
